import { render } from "./Data5.vue?vue&type=template&id=27fe5f06"
import script from "./Data5.vue?vue&type=script&lang=js"
export * from "./Data5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__